import React from "react";

import Layout from "@components/Layout";
import PortfolioProject from "@components/Portfolio/PortfolioProject";

interface StaticProps {
  title: string;
  description: string;
}

interface Props {
  title: string;
  description: string;
}

const Portfolio = ({ title, description, ...props }: Props) => {
  return (
    <>
      <Layout pageTitle={title} description={description}>
        <div className="max-w-screen-xl m-auto p-4 md:p-8">
          <main>
            <h1 className="text-4xl font-bold line leading-10 mb-4">
              Portfolio
            </h1>
            <div className="flex flex-wrap">
              <PortfolioProject
                title={"Ambience"}
                description={
                  "Give everyone access to world class synthesizer sounds with just the type of a url. As a member of a band, we often want a 'drone' sound effect to fill out the mix that will blend well with whatever chord is being played in a particular key. This allows anyone to get that sound easily."
                }
                url="https://ambience.vercel.app/"
                image="/img/portfolio/ambience.png"
              ></PortfolioProject>
              <PortfolioProject
                title={"Three Realms"}
                description={
                  "A simple, run anywhere 3D game written using Three.js. The goal is to create a multiplayer interactive game for company team building that can immediately run on any device."
                }
                url="https://threerealms.fly.dev/"
                image="/img/portfolio/threerealms.png"
              ></PortfolioProject>
              <PortfolioProject
                title={"Treasure"}
                description={
                  "Treasure is simple. Just record what you are thankful for each day. You'll be amazed at how your outlook changes and you'll have a great selection of memories to look back on later. Social media can just feel like too much comparison and showing off. Treasure helps us to enjoy the simple things."
                }
                url="/treasure"
                image="/img/portfolio/treasure.png"
              ></PortfolioProject>
              <PortfolioProject
                title={"Scraply"}
                description={
                  "Scraply was an entry to Startup Weekend that I led. To prove the business we manage to make our first sale within the weekend. The goal was to reduce waste by repurposing household kitchen waste into compost in people's backyards."
                }
                url="https://www.youtube.com/watch?v=fSVTEj1wLtc"
                image="/img/posts/scraply-presenting.jpg"
              ></PortfolioProject>
              <PortfolioProject
                title={"Quizventure"}
                description={
                  "Quizventure is a free and easy way to gamify your Moodle course using questions you’ve already written and just 1 plugin. Completely open source with many public contributors over the years. During 'project week' at Moodle, I designed and built a space shooter game where course quiz questions would fly down as ships, and you need to shoot the correct answer to win. The goal was to gamify learning in a simple, yet fun way. It has been installed on 2030 sites."
                }
                url="https://moodle.org/plugins/view.php?plugin=mod_quizgame"
                image="/img/portfolio/quizventure.png"
              ></PortfolioProject>
              <PortfolioProject
                title={"Online Shopping"}
                description={
                  "After having her heart broken Ellie takes matters into her own hands and orders herself a boyfriend. Unreleased film I wrote & directed with friends."
                }
                url="https://www.youtube.com/watch?v=k8Vg3bZF9i4"
                image="/img/portfolio/online-shopping.png"
              ></PortfolioProject>
              <PortfolioProject
                title={"Teleportation"}
                description={
                  "Short film entrant into the Allianz explorer competition. The theme was transport of the future. Filmed in Perth and Reykjavik."
                }
                url="https://www.youtube.com/watch?v=U1In7MmRbRg"
                image="/img/portfolio/teleportation.png"
              ></PortfolioProject>
            </div>
          </main>
        </div>
      </Layout>
    </>
  );
};

export default Portfolio;

export async function getStaticProps(): Promise<{ props: StaticProps }> {
  const configData = await import(`../siteconfig.json`);

  return {
    props: {
      title: `Portfolio | ${configData.default.title}`,
      description: configData.default.description,
    },
  };
}
